var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.941,
    height: 33.57,
    viewBox: "0 0 26.941 33.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256",
    transform: "translate(-482.704 -538.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M160.79,57.482a.771.771,0,0,1,.258.052.763.763,0,0,1,.225.136.771.771,0,0,1,.165.2.763.763,0,0,1-.408,1.088,11.234,11.234,0,0,0-3.664,18.756.763.763,0,0,1,.235.677l-.969,6.2,11.9,3.105.571-4.372a.763.763,0,0,1,.926-.645l3.557.811.609-3.723a.763.763,0,0,1,.753-.64h2.531l-1.431-6.8a.755.755,0,0,1-.016-.183l.132-3.907a11.246,11.246,0,0,0-6.813-9.13.763.763,0,1,1,.592-1.406,12.773,12.773,0,0,1,7.745,10.427.765.765,0,0,1,0,.1l-.13,3.871,1.606,7.63a.763.763,0,0,1-.747.92h-2.823l-.635,3.884a.763.763,0,0,1-.922.621l-3.531-.805-.574,4.4a.763.763,0,0,1-.949.64l-13.4-3.5a.763.763,0,0,1-.561-.856l1.014-6.492a12.759,12.759,0,0,1,4.46-21.019.764.764,0,0,1,.3-.053Z",
    transform: "translate(330.469 482.236)",
    fill: "#a0a0a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M278.113,33.578a.8.8,0,0,1,.3.06.736.736,0,0,1,.238.167.783.783,0,0,1,.167.25.737.737,0,0,1,.06.286V45.593a5.106,5.106,0,0,1,.7,8.451l1.776,3.075a.771.771,0,0,1,.1.286.755.755,0,0,1-.012.3.731.731,0,0,1-.131.262.789.789,0,0,1-.226.2.774.774,0,0,1-.286.1.743.743,0,0,1-.3-.024.784.784,0,0,1-.274-.131.745.745,0,0,1-.191-.226l-1.776-3.075a5.049,5.049,0,0,1-1.86.358,5.109,5.109,0,0,1-2.491-9.572V34.341a.736.736,0,0,1,.06-.286.786.786,0,0,1,.167-.25.732.732,0,0,1,.238-.167.8.8,0,0,1,.3-.06h3.445Z",
    transform: "translate(219.53 504.512)",
    fill: "#a0a0a0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9a191520790c2e78aad0d5aa00c5df3f.svg";
export { ForwardRef as ReactComponent };